/** Shared admin catalog UI variables (colors, radii, shadows, fonts). */

export const COLOR_TEXT_PRIMARY = '#1a1f36';
export const COLOR_TEXT_SECONDARY = '#5b6477';
export const COLOR_TEXT_MUTED = '#6b7385';
export const COLOR_TEXT_CODE = '#3d4f6f';

export const COLOR_BRAND = '#3559c7';
export const COLOR_BRAND_HOVER = '#2d4bb0';
export const COLOR_BRAND_SOFT = '#eef4ff';
export const COLOR_BRAND_SOFT_TEXT = '#3559c7';

export const COLOR_BORDER = '#e4e8f0';
export const COLOR_BORDER_SUBTLE = '#eef1f6';
export const COLOR_BORDER_INPUT = '#d7dde7';

export const COLOR_SURFACE = '#fff';
export const COLOR_SURFACE_MUTED = '#f8fafc';
export const COLOR_SURFACE_TOOLBAR = '#fcfdfe';
export const COLOR_SURFACE_HOVER = '#fafbfd';
export const COLOR_SURFACE_INSET = '#f3f5f8';

export const COLOR_FOCUS_BORDER = '#94b4ff';
export const COLOR_FOCUS_RING = 'rgba(53, 89, 199, 0.12)';

export const COLOR_SUCCESS_SOFT = '#ecfdf3';
export const COLOR_SUCCESS_TEXT = '#067647';

export const COLOR_DANGER = '#b42318';
export const COLOR_DANGER_SOFT = '#fef3f2';
export const COLOR_DANGER_BORDER = '#fecdca';

export const COLOR_BREADCRUMB_SEP = '#c5cedd';

export const RADIUS_SM = '6px';
export const RADIUS_MD = '8px';
export const RADIUS_LG = '10px';
export const RADIUS_XL = '12px';
export const RADIUS_PILL = '999px';

export const SHADOW_CARD = '0 1px 2px rgba(16, 24, 40, 0.04)';

export const FONT_MONO = 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace';
